{"NODE_ENV":"development","APP_DOMAIN":"https://stravinsky.xukev.in"}